module.exports = __webpack_public_path__ + "img/passport.5983f395.png";